<div class="spacing" *ngIf="!loading && orders.value">
  <div class="bolder margin-bottom-sm"> {{orders.value[0].productShortName }} <button class="btn btn--solid btn--right btn--red"
      (click)="goToProductPage(orders.value[0].productShortName)"> {{orders.value[0].productShortName}} Registrations </button></div>
  <table class="mat-elevation-z8 grayBackground" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="productShortName">
      <th mat-header-cell *matHeaderCellDef> Order </th>
      <td mat-cell *matCellDef="let order"> 
        <div>{{order.orderLineNumber}}. {{order.productLongName}} (#{{order.orderNumber}})</div>
          <div>Academic Year: {{order.beginDate | date: 'MMMM d, yyyy'}} - {{order.endDate | date: 'MMMM d, yyyy'}}</div>
        </td>
    </ng-container>
    <ng-container matColumnDef="seatQuantity">
      <th mat-header-cell *matHeaderCellDef> Quantity </th>
      <td mat-cell *matCellDef="let order"> {{order.quantity}} </td>
    </ng-container>
    <ng-container matColumnDef="orderDate">
      <th mat-header-cell *matHeaderCellDef> Order Date </th>
      <td mat-cell *matCellDef="let order"> {{order.orderDate | date: 'MMMM d, yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="actualBalanceAmmount">
      <th mat-header-cell *matHeaderCellDef> Balance Due </th>
      <td mat-cell *matCellDef="let order"> ${{order.actualBalanceAmount}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
  </table>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
